export const APP_STORE_URL =
  'https://apps.apple.com/ph/app/tradewingllc/id6742144752';

export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.app.tradewing&pcampaignid=web_share';

export const TRADEWING_APP_LOGO_SRC = '/images/tradewing-app-logo.png';

export type DevicePlatform = 'ios' | 'android' | 'desktop';

/** Platform from a user-agent string (server or client). iPadOS desktop-mode Safari reports as Mac, so it resolves to 'desktop' here. */
export const platformFromUserAgent = (ua: string): DevicePlatform => {
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';
  if (/Android/i.test(ua)) return 'android';
  return 'desktop';
};

/** Client-side detection, including iPadOS which pretends to be a Mac. */
export const detectClientPlatform = (): DevicePlatform => {
  if (typeof navigator === 'undefined') return 'desktop';
  const fromUa = platformFromUserAgent(navigator.userAgent || '');
  if (fromUa !== 'desktop') return fromUa;
  const isIPadOS =
    navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  return isIPadOS ? 'ios' : 'desktop';
};
